<template>
  <div class="app-container">
  </div>
</template>

<script>
import { useScreenState } from "../../store";
import paccount from "../../utils/paccount"

export default {
  name: "ForgetAccount",
  data() {
    return {
      screenState: useScreenState(),
    };
  },
  computed: {
    isCollapse() {
      return this.screenState.screenWidth < 900;
    },
  },
  methods: {
  },
  beforeMount() {
  },
  mounted() {
      paccount.pushPage('forgetaccount', this)
  },
  unmounted () {
      paccount.unmountPage(this.$route.fullPath)
  },
};
</script>

<style scoped>
</style>